/* repo/possoftware*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString
} from "./api";
import {
  PosSoftwareCodec,
  PosSoftware,
  Data
} from "../store/possoftware/types";
import { withDecoded, flattenData } from "./";

export const idLens = lensPath(["id"]);

function mapToModel(data: object): PosSoftware {
  return withDecoded(PosSoftwareCodec, data, decoded => ({
    ...decoded
  }));
}

function mapToChageset(processor: Data): Data {
  return processor;
}

export async function fetch(
  id: string | null,
  params?: {}
): Promise<PosSoftware> {
  return fetchApi({
    nestedResourcePath: ["possoftware"],
    id: id,
    params: params
  }).then(response =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(processor: Data): Promise<PosSoftware> {
  return insertApi({
    nestedResourcePath: ["possoftware"],
    id: processor.id,
    data: { data: mapToChageset(processor) }
  }).then(response =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["possoftware"],
    id: id
  }).then(() => true);
}
